import template from './performance_dashboard.html';
import * as Navbar from '../../lib/update_navbar_notifications.js';
import tr from '../../lib/default-translator.js';
import * as performance_dashboard_tutorial_config  from '../../components/tutorial_component/performance_dashboard_tutorial_config.js';

class PerformanceDashboardViewModel
{
    constructor(page)
    {
        this.page = page;

        this.tutorial_config = ko.observable(performance_dashboard_tutorial_config);

		 let config = this.tutorial_config().performance_dashboard_tutorial_config;
    };

    btn_show_cycle_setup_help()
    {
        Grape.dialog.open('PerformanceCyclesHelp', {});
    }

    btn_show_company_goals_help()
    {
        Grape.dialog.open('CompanyGoalsHelp', {});
    }

    btn_show_link_perf_cycles_help()
    {
        Grape.dialog.open('SetLinkPerfCyclesHelp', {});
    }

    btn_show_objectives_measures_help()
    {
        Grape.dialog.open('SetObjectivesMeasuresHelp', {});
    }

    btn_show_performance_progress_help()
    {
        Grape.dialog.open('PerformanceProgressReportHelp', {});
    }

    btn_show_self_review_rating_help()
    {
        Grape.dialog.open('SelfReviewRatingHelp', {});
    }
    
    btn_show_peer_review_rating_help()
    {
        Grape.dialog.open('PeerReviewRatingHelp', {});
    }

    btn_show_manager_review_rating_help()
    {
        Grape.dialog.open('ManagerReviewRatingHelp', {});
    }

    btn_show_cycle_stages_help()
    {
        Grape.dialog.open('CycleStageHelp', {});
    }   
    
    btn_show_rating_methods_help()
    {
        Grape.dialog.open('RatingMethodsHelp', {});
    }

    btn_show_manager_review_dialog()
    {
		
		Grape.dialog.open('RatingAndFeedback', {  manager: true });
	}


    btn_show_peer_review_dialog()
    {
		Grape.dialog.open('RatingAndFeedback', { peer: true });
	}

};

class PerformanceDashboardPage
{
    constructor(bindings)
    {
        this.bindings = bindings;
        this.viewModel = new PerformanceDashboardViewModel(this);
    }

    init()
    {
        document.title = tr('Performance Management Dashboard');
        window.current_page_title('Performance Management Dashboard');
    }

    updateData()
    {

    }
}

export default {
    route: '[/]performance_management/performance_dashboard',
    page_class: PerformanceDashboardPage,
    template: template,
    template_filename: 'translation/performance_dashboard'
};